var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "codeTest" },
    [
      _c(
        "div",
        { staticClass: "crumbs" },
        [
          _c("img", {
            staticClass: "a1",
            attrs: { src: require("@/assets/newicons/i001.png"), alt: "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          }),
          _c("span", { staticStyle: { "margin-right": "10px" } }, [
            _vm._v("返回"),
          ]),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("代码安装检测"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "testContent" }, [
        _c(
          "div",
          {
            staticClass: "main1",
            staticStyle: { "padding-top": "44px", "padding-left": "206px" },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("检查范围：")]),
            _c("div", { staticClass: "Range" }, [
              _c(
                "div",
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.radio,
                        callback: function ($$v) {
                          _vm.radio = $$v
                        },
                        expression: "radio",
                      },
                    },
                    [_vm._v("默认站点")]
                  ),
                  _vm.options.length > 0
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.options[_vm.options.length - 1].siteName)
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.radio,
                        callback: function ($$v) {
                          _vm.radio = $$v
                        },
                        expression: "radio",
                      },
                    },
                    [_vm._v("其他站点")]
                  ),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        "popper-class": "popClass",
                      },
                      model: {
                        value: _vm.selectId,
                        callback: function ($$v) {
                          _vm.selectId = $$v
                        },
                        expression: "selectId",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: { label: item.siteName, value: item.id },
                        },
                        [_vm._v(_vm._s(item.siteName))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "fx", staticStyle: { "margin-bottom": "38px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "dialog-confirm" },
                      on: { click: _vm.clickCheck },
                    },
                    [_vm._v("开始检测")]
                  ),
                  _c("div", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    attrs: {
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-text":
                        "检测过程需要一点时间，请待心等待！",
                    },
                  }),
                ],
                1
              ),
              _vm.codeTest == 1
                ? _c(
                    "p",
                    {
                      class: [
                        "status001",
                        _vm.codeTest == 1 || _vm.codeTest == 2 ? "fu-ll" : "",
                      ],
                      staticStyle: { color: "#999999", "font-size": "13px" },
                    },
                    [
                      _vm._v("页面代码安装状态："),
                      _c(
                        "span",
                        { staticStyle: { color: "rgba(255, 80, 0, 1)" } },
                        [_vm._v("尚未检测到代码！")]
                      ),
                      _vm._v("请阅读"),
                      _c(
                        "router-link",
                        {
                          staticStyle: { color: "#5088FF" },
                          attrs: { to: "/zxk/junbros/codeExplain" },
                        },
                        [_vm._v("代码安装页面说明")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.codeTest == 2
                ? _c(
                    "p",
                    {
                      class: [
                        "status001",
                        _vm.codeTest == 1 || _vm.codeTest == 2 ? "fu-ll" : "",
                      ],
                      staticStyle: { color: "#999999", "font-size": "13px" },
                    },
                    [
                      _vm._v("页面代码安装状态："),
                      _c("span", { staticStyle: { color: "#409EFF" } }, [
                        _vm._v("代码检测成功"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
        _c(
          "div",
          {
            class: [_vm.codeTest == 1 || _vm.codeTest == 2 ? "fu-ll" : ""],
            staticStyle: { "padding-left": "274px" },
          },
          [_vm._m(0)]
        ),
        _vm._m(1),
      ]),
      _c("setDrawer", { ref: "setDrawer" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint cls001" }, [
      _c("div", { staticClass: "a1" }, [
        _c("i", { staticClass: "el-icon-warning" }),
        _vm._v(" "),
        _c("span", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("温馨提示："),
        ]),
      ]),
      _c("div", { staticClass: "a2" }, [
        _c("p", [
          _vm._v(
            "1.检测过程中会打开一个弹窗，如果您的浏览器禁止弹窗，请允许弹窗"
          ),
        ]),
        _c("p", [_vm._v("2.整个检测过程大概需要1分钟时间")]),
        _c("p", [_vm._v("3.请等检测完毕再关闭弹窗")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "hint",
        staticStyle: {
          margin: "0 -24px",
          "margin-top": "123px",
          background: "none",
          padding: "0",
          "padding-top": "23px",
          "border-top": "1px solid rgba(241, 241, 242, 1)",
          "padding-left": "24px",
          "padding-right": "24px",
        },
      },
      [
        _c("div", { staticClass: "a1" }, [
          _c("span", { staticStyle: { "margin-left": "0px" } }, [
            _vm._v("小贴士："),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "a2",
            staticStyle: { "line-height": "22px", "padding-left": "0px" },
          },
          [
            _c("p", [
              _vm._v("1.为全面识别访客，请在网站的上正确安装统计代码；"),
            ]),
            _c("p", [
              _vm._v(
                "2.本功能通过抓取网站页面，分析是否安装了正确的统计代码，但有的网站打开速度较慢，或者限制程序抓取网页，会导致系统无法判断。这种情况下，请联系网站管理员了解代码的实际安装情况；"
              ),
            ]),
            _c("p", [
              _vm._v(
                "3.正确安装统计代码后，一般10分钟左右后，即可以查看到相关的识别统计数据，请耐心等待。"
              ),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }